$(function() {
    $('.js-save-cookie-changes').on('click', function(){
        
        $('#cookie-banner-form').addClass('is-hidden');
        $('.cookie-banner-success').addClass('is-visible');

        window.setTimeout(function(){
            hideCookieBanner();
        }, 1500);

        $('#cookie-banner-form').request('cookieBanner::onSaveChanges', {
            success: function(response) {

            }
        });
    });

    $('.js-show-cookie-details').on('click', function(){
        toggleDetails();
    });

    function hideCookieBanner() {
        $('#cookie-banner').addClass('is-hidden');
    }

    function toggleDetails() {
        $('.cookie-banner-details').toggleClass('is-visible');
    }
});
